import React from 'react';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Check } from '@mui/icons-material';
import NewCopyIcon from '@src/assets/icons/new-copy-icon.svg';
import { CRM_URL } from '@src/configs';
import MobileWeb from '@src/assets/images/mobile-desktop.svg';
import sanitize from 'sanitize-html';
import routes from '@src/constants/route';
import { MobileProjectContainer } from './index.style';

const ProjectOnMobile = () => {
  const { t } = useTranslation();
  const [copied, setCopied] = React.useState(false);
  const handleClickCopy = () => {
    navigator.clipboard.writeText(`${CRM_URL}${routes.PROJECT}`);
    setCopied(true);
  };

  return (
    <MobileProjectContainer>
      <div style={{ textAlign: 'center' }}>
        <img
          className="icon-mobile-web"
          src={MobileWeb}
          alt="icon-mobile-web"
        />
      </div>
      <div
        className="noti-mobile-project"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: sanitize(t('notiMobileProject')),
        }}
      />
      <Button onClick={handleClickCopy} className="button-copy-url">
        {!copied ? (
          <img src={NewCopyIcon} alt="copy-icon" className="copy-icon" />
        ) : (
          <Check className="checked-icon" />
        )}
        <Typography className="btn-copy-text">
          {!copied ? t('copyUrl') : t('copiedv2')}
        </Typography>
      </Button>
    </MobileProjectContainer>
  );
};

export default ProjectOnMobile;
